var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-form"},[_c('h3',[_vm._v("Документы для этого приза подписаны, ожидайте вручения")]),_c('v-btn',{on:{"click":function($event){_vm.$router.push({ name: 'LcMain' }).catch(() => {})}}},[_vm._v("На главную")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }